module.exports = __webpack_public_path__ + "img/balance_bg.3af6e399.png";